import { unsafeCSS as h, LitElement as p, html as f } from "lit";
import { property as s } from "lit/decorators.js";
import { validPropertyValues as l, defineCustomElement as u } from "@justeattakeaway/pie-webc-core";
const g = `*,*:after,*:before{box-sizing:inherit}.c-divider{--divider-bg-color: var(--dt-color-divider-default);--divider-width: 100%;--divider-height: 1px;margin:0;border:0;width:var(--divider-width);height:var(--divider-height);background-color:var(--divider-bg-color)}.c-divider[variant=inverse]{--divider-bg-color: var(--dt-color-divider-inverse)}.c-divider[orientation=vertical]{--divider-width: 1px;--divider-height: 100%}
`, m = ["default", "inverse"], b = ["horizontal", "vertical"];
var y = Object.defineProperty, w = Object.getOwnPropertyDescriptor, c = (d, r, e, t) => {
  for (var i = t > 1 ? void 0 : t ? w(r, e) : r, n = d.length - 1, a; n >= 0; n--)
    (a = d[n]) && (i = (t ? a(r, e, i) : a(i)) || i);
  return t && i && y(r, e, i), i;
};
const v = "pie-divider";
class o extends p {
  constructor() {
    super(...arguments), this.variant = "default", this.orientation = "horizontal";
  }
  render() {
    const { variant: r, orientation: e } = this;
    return f`
            <hr
                data-test-id="pie-divider"
                aria-hidden="true"
                class="c-divider"
                variant=${r || "default"}
                orientation=${e || "horizontal"}
            />`;
  }
}
o.styles = h(g);
c([
  s({ type: String }),
  l(v, m, "default")
], o.prototype, "variant", 2);
c([
  s({ type: String }),
  l(v, b, "horizontal")
], o.prototype, "orientation", 2);
u(v, o);
export {
  o as PieDivider,
  b as orientations,
  m as variants
};
